import { render, staticRenderFns } from "./StampPreviewCanvas.vue?vue&type=template&id=a656a8fc&scoped=true&"
import script from "./StampPreviewCanvas.vue?vue&type=script&lang=js&"
export * from "./StampPreviewCanvas.vue?vue&type=script&lang=js&"
import style0 from "./StampPreviewCanvas.vue?vue&type=style&index=0&id=a656a8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a656a8fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a656a8fc')) {
      api.createRecord('a656a8fc', component.options)
    } else {
      api.reload('a656a8fc', component.options)
    }
    module.hot.accept("./StampPreviewCanvas.vue?vue&type=template&id=a656a8fc&scoped=true&", function () {
      api.rerender('a656a8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/shared/StampPreviewCanvas.vue"
export default component.exports